
import Vue from 'vue'
import CustomModal from './CustomModal.vue'
import RButton from '@/components/forms/RButton.vue'

/**
 * This modal was created because Custom modal is only a basis,
 * while the BundleWrokstationDetailsModal is a bit different.
 * It serves as a template for good old text modals, with styling,
 * text positioning and all that.
 */

export default Vue.extend({
  name: 'CustomTextModal',
  components: {
    CustomModal,
    RButton,
  },
  props: {
    pending: {
      type: Boolean,
      default: false,
    },
    clickAwayClose: {
      type: Boolean,
      default: true,
    },
    hasBackButton: {
      type: Boolean,
    },
    title: {
      type: String,
      default: 'Hi',
    },
    // some of modals have centered, slightly bigger font.
    centered: {
      type: Boolean,
      default: false,
    },
    closingX: {
      type: Boolean,
      default: true,
    },
    name: {
      type: String,
    },
    maxWidth: {
      type: [String, Number],
    },
    minWidth: {
      type: [String, Number],
    },
    explicitBodyStyles: {
      type: Object,
    },
    secondaryButtonText: {
      type: String,
      default: 'Back',
    },
  },
  data(): { visible: boolean } {
    return {
      visible: false,
    }
  },
  // listen to plugin emissions
  created() {
    const { subscription } = this.$rModal
    subscription.$on('show', this.show)
    subscription.$on('hide', this.hide)
  },
  beforeDestroy() {
    const { subscription } = this.$rModal
    subscription.$off('show', this.show)
    subscription.$off('hide', this.hide)
    this.handleClose()
  },
  methods: {
    show({ name, options }: { name: string; options?: any }): void {
      if (this.name === name) {
        this.$emit('before-show', options)
        this.visible = true
        this.$emit('showed')
      }
    },
    // this one comes from the plugin
    hide({ name, options }: { name: string; options?: any }): void {
      if (this.name === name) {
        this.$emit('before-hide', options)
        this.visible = false
        this.$emit('hidden', options)
      }
    },
    // ... and this one from within modal itself
    handleClose(): void {
      const { pending, name } = this
      if (!pending) {
        this.hide({ name })
      }
    },
  },
  computed: {
    textClasses(): string[] {
      return this.centered ? ['text-center', 'text-bigger'] : []
    },
  },
})
